import styled from 'styled-components';
import { Link } from '@/shared/ui/link';
import { BodyTextRegularB } from '@/shared/ui/typography2';
import { useCurrentLocale, useScopedI18n } from '@locales/client';
import { Line, TitleContainer } from '@/shared/ui/footer/styles';

export const InfoBlock = () => {
  const t = useScopedI18n('common.footer');
  const locale = useCurrentLocale();

  return (
    <BlockWrapper>
      <TitleContainer>
        <BodyTextRegularB color="#AFAFAF">
          {t('info_title').toUpperCase()}
        </BodyTextRegularB>
        <Line $hideOnMobile />
      </TitleContainer>

      <Content>
        <Link
          href={{
            pathname: `/${locale}/info`,
            query: { id: 'rg' },
          }}
        >
          <BodyTextRegularB color="#FFF">{t('responsible')}</BodyTextRegularB>
        </Link>
        <Link
          href={{
            pathname: `/${locale}/info`,
            query: { id: 'pp' },
          }}
        >
          <BodyTextRegularB color="#FFF">{t('privacy')}</BodyTextRegularB>
        </Link>
        <Link
          href={{
            pathname: `/${locale}/info`,
            query: { id: 'aml' },
          }}
        >
          <BodyTextRegularB color="#FFF">{t('aml_privacy')}</BodyTextRegularB>
        </Link>
        <Link
          href={{
            pathname: `/${locale}/info`,
            query: { id: 'ua' },
          }}
        >
          <BodyTextRegularB color="#FFF">
            {t('user_agreement')}
          </BodyTextRegularB>
        </Link>
      </Content>
    </BlockWrapper>
  );
};

const BlockWrapper = styled.section`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 12px;
`;
const Content = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: 1fr 1fr;
  gap: 12px;
  @media screen and (min-width: 641px) {
    grid-template-columns: repeat(4, 1fr);
    grid-template-rows: 1fr;
  }
  @media screen and (min-width: 841px) {
    grid-template-columns: 1fr;
    grid-template-rows: repeat(4, 1fr);
  }
`;
